<style scoped lang="scss"></style>
<template>
	<div style="display: inline;">


		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/supplier/material/page" getKey="rows"
			:columns="columns">
			<template #top>
			</template>

			<!-- 左侧按钮插槽 -->
			<template #buttonsL>

				<yi_cross_select v-if="refresh" :key="key" :selectTitle="'name'" ref="material" :component="'web_base_matter_list'"
					:max="9999" :ids.sync="materialList" multiple :isInput="true" :isButton="true" :buttonTitle="'xinzeng'"
					@getItems="getItems" :fixConditions="{ notMaterialIds: notMaterialIds }">
				</yi_cross_select>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">

					<el-col :span="0.1">
						<el-button type="text" :loading="yt.editObj.loading"
							v-if="utils.checkPower('web_wms_supplier_material_delete')" class="font-color-danger"
							@click="yt.remove(scope.row, '/web/supplier/material/delete')">{{ $t('shanchu') }}
						</el-button>
					</el-col>
				</el-row>
			</template>

		</yi_curd_table>
		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->


		</el-dialog>
	</div>
</template>

<script type="text/javascript">
// import curd_data from '@/common/curd/curd_data';
export default {
	name: 'web_wms_supplier_material',
	data() {
		return {
			refresh:true,
			notMaterialIds: [],
			supplierList: [],
			columns: [{
				label: 'wuliaobianma',
				prop: 'material.code',
				sort: 'string',
				width: 200
			}, {
				label: 'wuliaomingcheng',
				prop: 'material.name',
				sort: 'string',
				width: 200
			}, {
				label: 'jibenfenlei',
				prop: 'material.type',
				type: 'dictionary',
				key: 'CUSTOMER_MATERIAL_TYPE',
				width: 200
			}, {
				label: 'chanpinfenlei',
				prop: 'material.value',
				type: 'dictionary',
				key: 'GYLXCPFL',
				width: 300
			}, {
				label: 'caozuo',
				type: 'slot',
				fixed: 'right'
			}]
		};
	},
	created() {
		setTimeout(() => {
			// table列表接口请求参数
			this.yt.conditions = {
				supplierId: this.$attrs.suppliers.id
			}
			this.yt.get(1);
			this.getSupplierMaterialList();

		}, 300)


	},
	methods: {
		// 获取选中数据
		getItems(checks) {
			if (checks.length === 0) {
				return;
			}
			let items = [];
			console.log("checks", checks);
			for (let i = 0; i < checks.length; i++) {
				items.push(checks[i]['id']);
			}
			this.insertSave(items);
			this.materialList = []
			this.refresh = false
			this.$nextTick(()=>{
				this.refresh = true
			})
			this.getSupplierMaterialList()
		},
		// 保存新增
		async insertSave(items) {
			let obj = {
				materialIds: items,
				supplierId: this.$attrs.suppliers.id
			};
			await this.http.post('/web/supplier/material/create', obj);

			this.yt.get(1);
		},
		// 获取供应商物料id
		 getSupplierMaterialList() {
			let obj = {
				supplierId: this.$attrs.suppliers.id
			};
			this.http.post('/web/supplier/material/getSupplierMaterialList', obj).then(response => {
				this.supplierList = response.data
				var str = "";
				this.supplierList.forEach(function (e) {
					str += e.materialId + ",";
				});
				str = str.substring(0, str.length - 1);
				this.notMaterialIds = str.split(",");
			})
		},
	},
};
</script>
